// Looks at scoring and determines if there is a composite score
// and if there is, prepares the number for display.
export default function findCompositeScore(scoring, isStudent, selectedStudent) {
  let compositeScore = 0
  if (scoring && scoring.byTest && scoring.byTest.scale) {
    const scale = scoring.byTest.scale
    if (isStudent || selectedStudent) {
      compositeScore = Math.round(scale)
    } else {
      compositeScore = Math.round(Number(scale) * 10) / 10
    }
  }
  const scale = scoring
  return scale ? compositeScore : 0 
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/assessmentDashboard/findCompositeScore.js